<div class="w-full md:w-2/3 mx-auto mt-8 mb-8 px-2 md:px-4">
  <div class="bg-gradient-to-r from-blue-30 to-indigo-50 border border-blue-100 rounded-lg p-2 md:p-6 shadow-sm">
    <h3
      class=" text-xl lg:text-2xl font-bold text-center uppercase bg-[oklch(90.5%_0.182_98.111)] italic  rounded-3xl w-full md:w-1/2 lg:w-2/3  text-black p-2 md:p-5 mx-auto mb-6 font-['Montserrat']">
      Obtiens ta prédiction IA Personnalisée
    </h3>

    <form [formGroup]="predictionForm" class="space-y-4" (ngSubmit)="onSubmitPrediction()">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div class="flex flex-col">
          <label for="team_1" class="text-sm font-medium text-white mb-1">Équipe 1</label>
          <input id="team_1" formControlName="team_1" type="text" pInputText placeholder="Ex: PSG"
            class="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 !text-[16px]" />
          <span *ngIf="predictionForm.get('team_1')?.invalid && predictionForm.get('team_1')?.touched"
            class="text-red-500 text-xs mt-1">
            Équipe 1 obligatoire
          </span>
        </div>

        <div class="flex flex-col">
          <label for="team_2" class="text-sm font-medium text-white mb-1">Équipe 2</label>
          <input id="team_2" formControlName="team_2" type="text" pInputText placeholder="Ex: Bayern"
            class="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 !text-[16px]" />
          <span *ngIf="predictionForm.get('team_2')?.invalid && predictionForm.get('team_2')?.touched"
            class="text-red-500 text-xs mt-1">
            Équipe 2 obligatoire
          </span>
        </div>

        <div class="flex flex-col">
          <label for="sport" class="text-sm font-medium text-white mb-1">Sport</label>
          <p-dropdown [options]="sports()" formControlName="sport" placeholder="Choisir sport" optionLabel="sport_name"
            optionValue="id" styleClass="w-full">
          </p-dropdown>
          <span *ngIf="predictionForm.get('sport')?.invalid && predictionForm.get('sport')?.touched"
            class="text-red-500 text-xs mt-1">
            Sport obligatoire
          </span>
        </div>

        <div class="flex flex-col">
          <label for="date" class="text-sm font-medium text-white mb-1">Date du match</label>
          <p-datepicker [minDate]="minDate" formControlName="date" dateFormat="dd/mm/yy" placeholder="Sélectionner date"
            inputStyleClass="p-3" styleClass="w-full !text-[16px]">
          </p-datepicker>
          <span *ngIf="predictionForm.get('date')?.invalid && predictionForm.get('date')?.touched"
            class="text-red-500 text-xs mt-1">
            Date obligatoire
          </span>
        </div>
      </div>

      <div class="bg-white border border-gray-200 rounded-lg p-4 mt-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <span class="text-lg font-semibold text-gray-700">Prix: {{priceUnitPrediction}} jeton</span>
            <div class="flex items-center space-x-2">
              <i class="pi pi-wallet text-blue-600"></i>
              <span class="text-sm text-gray-600">
                Vos crédits: <span class="font-semibold text-blue-600">{{ userCredits() }}</span> jeton
              </span>
            </div>
          </div>

          <div class="flex items-center space-x-2">
            <i
              [class]="userCredits() >= priceUnitPrediction ? 'pi pi-check-circle text-green-500' : 'pi pi-times-circle text-red-500'"></i>
            <span [class]="userCredits() >= 5 ? 'text-green-600 text-sm' : 'text-red-600 text-sm'">
              {{ userCredits() >= priceUnitPrediction ? 'Crédit suffisant' : 'Crédit insuffisant' }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col md:flex-row gap-3 mt-6">
        <p-button *ngIf="userCredits() >= priceUnitPrediction" type="button" label=" Obtiens ta prédiction"
          icon="pi pi-sparkles" [disabled]="predictionForm.invalid" styleClass="flex-1 p-button-lg p-button-success"
          (onClick)="confirmPurchase()">
        </p-button>

        <p-button *ngIf="userCredits() < priceUnitPrediction" label=" Acheter des jetons" icon="pi pi-shopping-cart"
          (onClick)="goToPayment()" styleClass="flex-1 p-button-lg p-button-warning">
        </p-button>

      </div>
    </form>
  </div>
</div>

<h2 class="text-xl md:text-3xl font-semibold text-center text-white  mt-7 pt-10">
  Prédictions sportives disponibles
</h2>

<div class="flex flex-col md:flex-row w-full md:w-2/3 mx-auto items-center justify-evenly gap-4 my-6 px-4">
  <div class="flex flex-col md:flex-row gap-4">
    <p-dropdown [options]="sportOptions()" placeholder=" Sport" optionLabel="label" optionValue="label"
      class="w-full md:w-56" (onChange)="onSportChange($event)"></p-dropdown>
    <p-multiselect [options]="competitionsOptions()" placeholder="Compétition" optionLabel="label" optionValue="label"
      display="chip" styleClass="w-full md:w-56" (onChange)="onCompetitionChange($event)" />
  </div>
</div>

@if(predictions().length === 0) {
@if(selectedSport() !==null) {
<div class="card">
  <p>Pas de probabilités correspondantes à ce filtre.</p>
</div>
}@else if (loading() === false ) {
<div class="card text-center w-1/2 mx-auto">
  <p>Aucune probabilités.</p>
</div>
}@else{
<div class="card mt-8 w-full md:w-2/3 mobile-padding mx-auto">

  <div class="flex items-center justify-between mb-4">
    <p-skeleton width="10rem" height="2rem"></p-skeleton>
    <p-skeleton shape="circle" size="2rem"></p-skeleton>
  </div>

  <div class="flex justify-center mt-4">
    <p-skeleton width="12rem" height="2rem"></p-skeleton>
  </div>

  <div class="flex flex-row text-center mt-4">
    <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
      <p-skeleton shape="circle" size="6rem"></p-skeleton>
      <p-skeleton width="6rem" class="mt-2"></p-skeleton>
      <p-skeleton width="10rem" height="0.5rem" class="mt-2"></p-skeleton>
      <p-skeleton width="4rem" class="mt-2"></p-skeleton>
    </div>

    <div class="w-full md:w-2/12 flex flex-col items-center justify-center py-5">
      <p-skeleton width="6rem" height="1.5rem"></p-skeleton>
      <p-skeleton width="4rem" height="1rem" class="mt-2"></p-skeleton>
    </div>

    <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
      <p-skeleton shape="circle" size="6rem"></p-skeleton>
      <p-skeleton width="6rem" class="mt-2"></p-skeleton>
      <p-skeleton width="10rem" height="0.5rem" class="mt-2"></p-skeleton>
      <p-skeleton width="4rem" class="mt-2"></p-skeleton>
    </div>
  </div>

  <div class="text-center mt-2">
    <p-skeleton width="12rem" height="1rem"></p-skeleton>
  </div>
</div>
}

}

@for(prediction of sortedPredictions(); track prediction ) {
@if(prediction.isAccessible) {


<div class="card mt-8 w-full md:w-2/3 mobile-padding  mx-auto">
  <div class="flex items-center justify-between mb-4">
    <div class="font-semibold text-xl"> {{prediction.competition}} </div>
    <p-button type="button" icon="pi pi-bell" [raised]="true" [severity]="prediction.isFollowed ? 'success' : 'warn'"
      [disabled]="loadingPredictionId() === prediction.id" [label]=" prediction.isFollowed? 'Suivi' : 'Suivre'" rounded
      (onClick)="toggleFollow(prediction)">
    </p-button>
  </div>
  <div class="flex justify-center mt-4">
    <button (click)="goToDetails(prediction.id)" pButton type="button" label="Voir l'analyse complète"
      class="p-button-sm p-button-outlined p-button-primary">
    </button>
  </div>

  <div class="flex flex-row :text-center ">





    <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
      <img [src]="prediction.team_home_logo_id ? prediction.team_home_logo_id : prediction.team_home_logo" alt="PSG"
        width="100" />
      <span class="text-sm md:text-lg mt-2 font-semibold"> {{prediction.team_home}} </span>

      <div class="w-28 md:w-40 mt-2 bg-surface-300 dark:bg-surface-500 rounded-full overflow-hidden"
        style="height: 8px;">
        <div [ngClass]="{
          'bg-red-500': prediction.confidence_team_home < 0.30, 
          'bg-orange-500': prediction.confidence_team_home >= 0.3 && prediction.confidence_team_home < 0.6,
          'bg-green-500': prediction.confidence_team_home >= 0.6
        }" class=" h-full" [style.width.%]="prediction.confidence_team_home * 100"></div>
      </div>
      <span [ngClass]="{
        'text-red-500': prediction.confidence_team_home < 0.30,
        'text-orange-500': prediction.confidence_team_home >= 0.3 && prediction.confidence_team_home < 0.6,

        'text-green-500': prediction.confidence_team_home >= 0.6
      }" class=" mt-1 font-medium">{{prediction.confidence_team_home *100}} %</span>
    </div>

    <div class="w-full md:w-2/12 flex flex-col items-center justify-center py-5">
      <div class="text-sm md:text-lg font-medium">{{ prediction.event_date | date: 'MMM d, y' }} </div>
      <div class="text-gray-500">{{ prediction.event_date | date: 'HH:mm' }}</div>
    </div>

    <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
      <img [src]="prediction.team_away_logo_id ? prediction.team_away_logo_id  : prediction.team_away_logo" alt="PSG"
        width="100" />
      <span class="mt-2 font-semibold"> {{prediction.team_away}} </span>

      <div class="w-28 md:w-40 mt-2 bg-surface-300 dark:bg-surface-500 rounded-full overflow-hidden"
        style="height: 8px;">
        <div [ngClass]="{
          'bg-red-500': prediction.confidence_team_away < 0.30, 
          'bg-orange-500': prediction.confidence_team_away >= 0.3 && prediction.confidence_team_away < 0.6,
          'bg-green-500': prediction.confidence_team_away >= 0.6
        }" class=" h-full" [style.width.%]="prediction.confidence_team_away * 100"></div>
      </div>
      <span [ngClass]="{
        'text-red-500': prediction.confidence_team_away < 0.30,
        'text-orange-500': prediction.confidence_team_away >= 0.3 && prediction.confidence_team_away < 0.6,

        'text-green-500': prediction.confidence_team_away >= 0.6
      }" class=" mt-1 font-medium">{{prediction.confidence_team_away*100}} %</span>
    </div>

  </div>
  <div class="text-sm text-gray-600 mt-2 text-center max-w-xs mx-auto">
    {{prediction.event_name}}
  </div>
  <div class="text-sm text-gray-600 mt-2 text-center max-w-xs mx-auto">
    Cote : {{prediction.cote}}
  </div>
</div>
} @else {
<div class="card mt-8 w-full md:w-2/3 mobile-padding mx-auto relative">
  <div class="absolute inset-0 bg-black/10 backdrop-blur-[2px] rounded-lg z-10 flex items-center justify-center">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-sm mx-4 text-center">
      <i class="pi pi-lock text-3xl text-yellow-500 mb-3"></i>
      <h3 class="font-semibold text-gray-800 mb-2">Débloquez cette prédiction</h3>

      <div *ngIf="prediction?.accessible_plans?.length" class="mb-4">
        <p class="text-base text-gray-600 mb-2">Accessible avec :</p>
        <div class="flex flex-wrap gap-1 justify-center">
          <span *ngFor="let plan of prediction.accessible_plans"
            class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            <i class="pi pi-crown mr-1 text-yellow-500" style="font-size: 10px;"></i>
            {{ plan.name }}
          </span>
        </div>
      </div>
      <p-button icon="pi pi-shopping-cart" label="Voir abonnements" size="small" (onClick)="goToSubscription()">
      </p-button>
    </div>
  </div>
  <div class="flex items-center justify-between mb-4">
    <div class="bg-gray-300 h-6 w-32 rounded "></div>

  </div>

  <div class="flex justify-center mt-4">
    <div class="bg-gray-300 h-10 w-40 rounded-md "></div>
  </div>
  <div class="flex flex-row text-center">
    <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
      <div class="bg-gray-300 rounded-full h-24 w-24 "></div>
      <div class="bg-gray-300 h-4 w-20 mt-2 rounded "></div>
      <div class="w-28 md:w-40 mt-2 bg-gray-300 rounded-full overflow-hidden" style="height: 8px;"></div>
      <div class="bg-gray-300 h-4 w-16 mt-2 rounded "></div>
    </div>

    <div class="w-full md:w-2/12 flex flex-col items-center justify-center py-5">
      <div class="bg-gray-300 h-4 w-24 mb-2 rounded "></div>
      <div class="bg-gray-200 h-3 w-16 rounded "></div>
    </div>

    <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
      <div class="bg-gray-300 rounded-full h-24 w-24 "></div>
      <div class="bg-gray-300 h-4 w-20 mt-2 rounded "></div>
      <div class="w-28 md:w-40 mt-2 bg-gray-300 rounded-full overflow-hidden" style="height: 8px;"></div>
      <div class="bg-gray-300 h-4 w-16 mt-2 rounded "></div>
    </div>
  </div>

  <div class="bg-gray-200 h-4 w-40 mx-auto mt-4 rounded "></div>
</div>

}

}



<p-dialog [(visible)]="showConfirmDialog" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '400px' }" header="Confirmer l'achat">

  <div class="text-center">
    <i class="pi pi-question-circle text-4xl text-blue-500 mb-4"></i>
    <h3 class="text-lg font-semibold mb-4">Confirmer votre demande</h3>

    <div class="space-y-2 text-left mb-6">
      <p><strong>Match :</strong> {{ predictionForm.get('team_1')?.value }} vs {{ predictionForm.get('team_2')?.value }}
      </p>
      <p><strong>Sport :</strong> {{ getSelectedSportName() }}</p>
      <p><strong>Date :</strong> {{ predictionForm.get('date')?.value | date:'dd/MM/yyyy' }}</p>
      <p><strong>Prix :</strong> {{ priceUnitPrediction }} jeton</p>
    </div>

    <p class="text-sm text-gray-600 mb-4">
      Votre prédiction sera traitée par nos experts et sera disponible dans les plus brefs délais.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button label="Annuler" icon="pi pi-times" (onClick)="showConfirmDialog = false" styleClass="p-button-text">
      </p-button>
      <p-button label="Confirmer l'achat" icon="pi pi-check" (onClick)="processPurchase()"
        [loading]="isSubmittingPrediction()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>


<p-toast [position]="isMobile ? 'bottom-center' : 'top-right'" [styleClass]="isMobile ? 'toast-mobile' : ''"></p-toast>